var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    clipPath: "url(#clip0_324_619)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_324_619)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.35352C0 21.5929 10.7452 32.3256 24 32.3256C37.2548 32.3256 48 21.5929 48 8.35352H0Z",
    fill: "#FBA021"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.89453 11.6602C5.05882 21.3107 13.6164 28.803 24.0002 28.803C34.384 28.803 42.9414 21.3107 44.106 11.6602H3.89453Z",
    fill: "#252D47"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_324_619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 33,
    width: 6,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5384 33.5723H21.5234V45.7151H26.5384V33.5723Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_324_619)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5234 33.5723H26.5384V45.7151H21.5234V33.5723Z",
    fill: "#FF8E16"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_324_619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 33,
    width: 6,
    height: 13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5234 33.5723H26.5384V45.7151H21.5234V33.5723Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_324_619)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_324_619)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6562 38.5723H30.8354V43.5723H18.6562V38.5723Z",
    fill: "#F07D42"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_324_619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 33,
    height: 37
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7947 0.714844H7.91406V36.072H39.7947V0.714844Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_324_619)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_324_619)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18359 1.0332V20.3198C8.18359 29.0058 15.246 36.0469 23.9578 36.0469C32.6697 36.0469 39.7322 29.0058 39.7322 20.3198V1.0332H8.18359Z",
    fill: "#FFB820"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18359 1.0332V20.3198C8.18359 29.0058 15.246 36.0469 23.9578 36.0469C32.6697 36.0469 39.7322 29.0058 39.7322 20.3198V1.0332H8.18359Z",
    fill: "url(#paint0_linear_324_619)",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_324_619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 34,
    height: 37
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18359 1.0332V20.3198C8.18359 29.0058 15.246 36.0469 23.9578 36.0469C32.6697 36.0469 39.7322 29.0058 39.7322 20.3198V1.0332H8.18359Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18359 1.0332V20.3198C8.18359 29.0058 15.246 36.0469 23.9578 36.0469C32.6697 36.0469 39.7322 29.0058 39.7322 20.3198V1.0332H8.18359Z",
    stroke: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_324_619)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter3_f_324_619)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05078 -2.85742H44.4538V7.14258H5.05078V-2.85742Z",
    fill: "#D2691B"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5075 -2.13331L-7.72266 51.9487L-3.66085 -10.002L38.5075 -2.13331Z",
    fill: "url(#paint1_linear_324_619)"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_324_619)"
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76172 2.14286C5.76172 0.959389 6.72398 0 7.91097 0H40.1498C41.337 0 42.2991 0.959389 42.2991 2.14286C42.2991 3.32633 41.337 4.28571 40.1498 4.28571H7.91097C6.72398 4.28571 5.76172 3.32633 5.76172 2.14286Z",
    fill: "#FFC155"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M5.76172 2.14286C5.76172 0.959389 6.72398 0 7.91097 0H40.1498C41.337 0 42.2991 0.959389 42.2991 2.14286C42.2991 3.32633 41.337 4.28571 40.1498 4.28571H7.91097C6.72398 4.28571 5.76172 3.32633 5.76172 2.14286Z",
    fill: "url(#paint2_linear_324_619)",
    fillOpacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9414 41.5658C17.9414 41.1712 18.2622 40.8516 18.6578 40.8516H29.452C29.8477 40.8516 30.1684 41.1712 30.1684 41.5658V43.6626C30.1684 44.0573 29.8477 44.3769 29.452 44.3769H18.6578C18.2622 44.3769 17.9414 44.0573 17.9414 43.6626V41.5658Z",
    fill: "#FFA62F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6578 40.8516C18.2622 40.8516 17.9414 41.1712 17.9414 41.5658V43.6626C17.9414 44.0573 18.2622 44.3769 18.6578 44.3769H29.452C29.8477 44.3769 30.1684 44.0573 30.1684 43.6626V41.5658C30.1684 41.1712 29.8477 40.8516 29.452 40.8516H18.6578Z",
    fill: "#FFA528"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_324_619)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9258 43.5717C12.9258 43.1771 13.2466 42.8574 13.6422 42.8574H34.4183C34.814 42.8574 35.1347 43.1771 35.1347 43.5717V49.286C35.1347 49.6806 34.814 50.0003 34.4183 50.0003H13.6422C13.2466 50.0003 12.9258 49.6806 12.9258 49.286V43.5717Z",
    fill: "#B26025"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M12.9258 43.5717C12.9258 43.1771 13.2466 42.8574 13.6422 42.8574H34.4183C34.814 42.8574 35.1347 43.1771 35.1347 43.5717V49.286C35.1347 49.6806 34.814 50.0003 34.4183 50.0003H13.6422C13.2466 50.0003 12.9258 49.6806 12.9258 49.286V43.5717Z",
    fill: "url(#paint3_linear_324_619)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.6602 44.2852H29.4064V48.5709H18.6602V44.2852Z",
    fill: "#FFF3D8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3303 25.8255C18.387 25.4898 18.4383 25.1837 18.4905 24.8778C18.7132 23.574 18.9361 22.2703 19.1589 20.9665C19.1952 20.7536 19.2383 20.5415 19.2636 20.3273C19.2707 20.2679 19.2434 20.1836 19.2009 20.1421C18.2667 19.2302 17.3282 18.3226 16.3905 17.4143C16.0498 17.0843 15.7087 16.7548 15.3685 16.4242C15.2013 16.2618 15.1152 16.071 15.193 15.8386C15.2734 15.5986 15.4576 15.4867 15.7014 15.4519C17.3957 15.2105 19.089 14.9627 20.7846 14.7318C21.0115 14.7009 21.13 14.6202 21.2316 14.4136C22.0068 12.838 22.7983 11.2702 23.5825 9.69879C23.6749 9.51351 23.7934 9.3734 24.0196 9.36926C24.2089 9.36572 24.3549 9.44183 24.441 9.61154C24.6345 9.99308 24.8248 10.3762 25.0154 10.7592C25.6532 12.0412 26.2901 13.3236 26.9306 14.6043C26.9503 14.6437 27.003 14.6857 27.0455 14.6919C28.295 14.8761 29.5452 15.0556 30.7953 15.2367C31.3239 15.3133 31.8522 15.3925 32.3809 15.4692C32.619 15.5038 32.7841 15.6319 32.8556 15.8579C32.9246 16.0764 32.8506 16.2656 32.6894 16.422C31.905 17.1834 31.1199 17.9443 30.3348 18.705C29.8384 19.1859 29.3431 19.668 28.8428 20.1449C28.7743 20.2102 28.7773 20.2742 28.7903 20.3502C28.9382 21.215 29.0858 22.0799 29.2339 22.9447C29.391 23.8627 29.549 24.7806 29.7055 25.6987C29.7394 25.8976 29.6793 26.063 29.5152 26.1868C29.3408 26.3184 29.158 26.3228 28.9678 26.2234C28.2668 25.8574 27.5655 25.4916 26.8644 25.1255C25.955 24.6505 25.0451 24.1766 24.1375 23.6984C24.0553 23.6551 23.9942 23.6589 23.9145 23.7007C22.3221 24.537 20.7281 25.3708 19.1346 26.2051C18.8366 26.3611 18.5625 26.307 18.4119 26.0524C18.3677 25.9779 18.3516 25.887 18.3303 25.8255Z",
    fill: "#FFEEB4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_324_619",
    x: 0,
    y: 8.35352,
    width: 48,
    height: 23.9727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.674847 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_324_619"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_324_619",
    x: 7.78313,
    y: 27.6991,
    width: 33.9259,
    height: 26.7462,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.43656,
    result: "effect1_foregroundBlur_324_619"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_324_619",
    x: 8.18359,
    y: 1.0332,
    width: 31.5469,
    height: 35.0137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.876585 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_324_619"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_324_619",
    x: -16.6954,
    y: -24.6036,
    width: 82.8947,
    height: 53.4924,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8731,
    result: "effect1_foregroundBlur_324_619"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_324_619",
    x: 5.76172,
    y: 0,
    width: 36.5391,
    height: 6.28516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.791752 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_324_619"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_324_619",
    x: 12.9258,
    y: 42.8574,
    width: 22.207,
    height: 7.14258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1967 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_324_619"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_324_619",
    x1: -2.58692,
    y1: 20.8195,
    x2: 26.8547,
    y2: 41.7376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.894418
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_324_619",
    x1: 8.93954,
    y1: -3.45478,
    x2: -6.43185,
    y2: 18.8291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_324_619",
    x1: -3.37259,
    y1: 2.14286,
    x2: -0.9902,
    y2: 12.2982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.610565,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_324_619",
    x1: 12.9258,
    y1: 42.8574,
    x2: 12.9258,
    y2: 50.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.0275702
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_324_619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro);
export default __webpack_public_path__ + "static/media/pro.d6cad79e256d24dfa55157957e21a7da.svg";
export { ForwardRef as ReactComponent };